import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from '../../../../ui/toast';
import { ADMIN_PAGES_KEYS, NS } from '../../../../i18n/constants/keys';
import { Button } from '../../../../ui';
import { SecondaryTypography } from '../../../../ui/typography/typography';

type BulkUploadModalProps = {
  inviteEmployeesFromCsv: (csvFile: File) => void;
};

export const BulkUploadModal = ({
  inviteEmployeesFromCsv,
}: BulkUploadModalProps) => {
  const { t } = useTranslation(NS.adminPages);
  const EM = ADMIN_PAGES_KEYS.employeeManagement;
  const [uploadedFile, setUploadedFile] = useState<File>();

  const addFileViaInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!uploadedFile) {
      const files = event.target.files;
      const splitFileString = files && files[0].name.split('.');
      if (
        files &&
        splitFileString &&
        splitFileString[splitFileString.length - 1] === 'csv'
      ) {
        setUploadedFile(files[0]);
      } else {
        toast.error(t(EM.bulkUpload.invalidFileType), {
          position: 'bottom-center',
        });
      }
    }
  };

  const handleDownload = () => {
    const fileUrl = process.env.PUBLIC_URL + '/files/employee_bulk_sample.csv';
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'employee_bulk_sample.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className='flex flex-col items-center p-5'>
      { uploadedFile ? (
        <>
          <SecondaryTypography.Small>
            { t(EM.bulkUpload.fileName) }: { uploadedFile.name }
          </SecondaryTypography.Small>
          <Button
              variant='primary'
              label={t(EM.bulkUpload.bulkInviteFromCsv)}
              onClick={() => inviteEmployeesFromCsv(uploadedFile)}
          />
        </>
      ) : (
        <>
          <input
              type='file'
              onChange={addFileViaInput}
              id='upload-file-input'
              style={{ display: 'none' }}
          />
          <Button
              variant='secondary'
              label={t(EM.bulkUpload.uploadFile)}
              onClick={() =>
                document.getElementById('upload-file-input')?.click()
              }
          />
          <Button
              variant='primary'
              label={t(EM.bulkUpload.downloadSampleCsv)}
              onClick={handleDownload}
          />
        </>
      ) }
    </div>
  );
};
